import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 25, message: 'Maximum number of characters reached' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 25, message: 'Maximum number of characters reached' }
      ]
    },
    clientName: {
      validations: [
        { type: 'maxLength', maxLength: 75, message: 'Maximum number of characters reached' }
      ]
    },
    addressLine1: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 75, message: 'Maximum number of characters reached' }
      ]
    },
    city: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 30, message: 'Maximum number of characters reached' }
      ]
    },
    state: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 30, message: 'Maximum number of characters reached' }
      ]
    },
    postal: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 15, message: 'Maximum number of characters reached' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 30, message: 'Maximum number of characters reached' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 75, message: 'Maximum number of characters reached' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of characters reached' }
      ]
    },
    eventExtra1: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of characters reached' }
      ]
    },
    eventExtra2: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of characters reached' }
      ]
    },
    eventExtra3: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of characters reached' }
      ]
    },
    eventExtra4: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of characters reached' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    siteName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 75, message: 'Maximum number of characters reached' }
      ]
    },    
    plannedGuestCount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 10, message: 'Maximum number of characters reached' }
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Business Name',
            mapping: 'clientName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address *',
            mapping: 'addressLine1'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City *',
            mapping: 'city'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State *',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'state'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip *',
            mapping: 'postal'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone *',
            mapping: 'telNumber'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event *',
            options: [
              { label: 'Catering', value: 'Catering' },
              { label: 'Rental', value: 'Rental' },
              { label: 'Catering & Rental', value: 'Catering & Rental' }
            ],
            mapping: 'theme'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Menu',
            options: [
              { label: 'Breakfast', value: 'Breakfast' },
              { label: 'Lunch', value: 'Lunch' },
              { label: 'Dinner', value: 'Dinner' },
              { label: 'Pig Roast', value: 'Pig Roast' },
              { label: 'Picnic', value: 'Picnic' },
              { label: 'Other', value: 'Other' }
            ],
            mapping: 'eventExtra1'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Type of Menu (Other)',
            mapping: 'eventExtra4'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Rental items interested in',
            mapping: 'eventExtra2'
          },
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date *',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Venue (please include city) *',
            mapping: 'siteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated no. of guests: *',
            mapping: 'plannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Delivery Needed',
            options: [
              { value: 'Yes', label: 'Yes'},
              { value: 'No', label: 'No'}
            ],
            mapping: 'eventExtra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Message regarding your event:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Biebels Catering Request a Quote',
    formId: '534',
    clientKey: '9EB3C403-D6F5-4F7F-AE90-DB0A9681D324',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you for your submission. We\'ll get back to you before the end of the next business day. Kim Agostine - Owner - Biebel\'s Catering & Rental',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/biebelscatering2/form_structure.js